/* eslint-disable eol-last */
import Vue from 'vue';
import VueApollo/* , {ApolloProvider} */ from 'vue-apollo';
import {createApolloClient/* , restartWebsockets */}
from 'vue-cli-plugin-apollo/graphql-client';
import {cache} from '@/state/initCache.js';
import {typeDefs, resolvers} from '@/state/schema.js';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token';

// Http endpoint
const httpEndpoint = process.env.NODE_ENV == 'production'
  ? process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'
  : 'http://localhost:4000/graphql';
// Files URL root
export const filesRoot =
  process.env.VUE_APP_FILES_ROOT
  || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'));

Vue.prototype.$filesRoot = filesRoot;

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  inMemoryCacheOptions: {
    freezeResults: false,
  },
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  // websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  cache,

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
  typeDefs,
  resolvers,
};
// Call this in the Vue app file
/**
 * Crear proveedor de Apollo
 * @param {Object} options Options
 * @return {ApolloProvider} Apollo
 */
export function createProvider(options = {}) {
  // Create apollo client
  const {apolloClient/* , wsClient */} = createApolloClient({
    ...defaultOptions,
    ...options,
  });
  // apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {
      let mensaje = 'Error desconocido mientras se consultaban los datos';
      if (error.message.indexOf('Network') == 0) {
        mensaje = 'Error de red. ¿Tenemos conexión a internet?';
      }
      if (this.alertaMsj) {
        this.alertaMsj = {
          content: mensaje,
          class_color: 'alert-warning-custom',
          icon: 'exclamation-triangle',
          iconPrefix: 'fas',
        };
      } else {
        alert(mensaje);
        // eslint-disable-next-line no-console
        // console.log('%cError', 'background: red; color: white; padding: 2px'
        // +' 4px; border-radius: 3px; font-weight: bold;', error.message);
      }
    },
  });

  return apolloProvider;
}

// Manually call this when user log in
/**
 * onLogin al hacer login
 * @param {apolloClient} apolloClient apollo Client
 * @param {String} token token de sesión
 */
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    // console.log('%cError on cache reset (li)', 'color: orange;', e.message);
  }
}

// Manually call this when user log out

/**
 * onLogin al hacer login
 * @param {apolloClient} apolloClient apollo Client
 * @param {String} token token de sesión
 */
export function onLogout(apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN);
  }
  // if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    // console.log('%cError on cache reset (lt)', 'color: orange;', e.message);
  }
}

/**
 * isAuthenticated valida si esta autenticado el usuario
 * @param {Function} to
 * @param {Function} from
 * @param {Function} next
 * @return {Boolean}
 */
export function isAuthenticated(to, from, next) {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(AUTH_TOKEN) ? next() : next('/login');
  }
}

/**
 * isAuthenticated valida si esta autenticado el usuario
 * @param {Function} to
 * @param {Function} from
 * @param {Function} next
 * @return {Boolean}
 */
export function isNotAuthenticated(to, from, next) {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(AUTH_TOKEN) ? next('/') : next();
  }
}